import CardGeneric from 'core/modules/components/cards/components/CardGeneric';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ChatbotPracticeSummary = ({ userName, activityResults = [], sessionKCs = [], lessonTitle }) => {
  const { t } = useTranslation(['chatbot']);
  // Separate KCs by mastery level
  const learnedKCs = sessionKCs.filter((kc) => kc.score > 0.9);
  const improvementKCs = sessionKCs.filter((kc) => kc.score <= 0.9);
  // Filter out from the improvementKCs then that are in activityResults without any error
  const improvementKCsWithError = improvementKCs.filter((kc) =>
    activityResults.some((activityResult) => activityResult.associatedKC === kc.referenceId && !activityResult.isCorrect)
  );

  return (
    <div className="ai-practice-view__summary">
      <CardGeneric>
        <div className="ai-practice-view__lesson-title">
          <div className="ai-practice-view__lesson-title-text" dangerouslySetInnerHTML={{ __html: lessonTitle }} />
        </div>
        <div className="ai-practice-view__summary-content">
          {/* Upper section with padding */}
          <div className="ai-practice-view__summary-upper-section">
            {/* Celebration section */}
            <div className="ai-practice-view__summary-celebration">
              <h2 className="ai-practice-view__summary-title">{t('practice_summary_good_job', { userName })}</h2>
              <div alt={t('practice_ai_bot_celebrating')} className="ai-practice-view__summary-celebration-image" />
            </div>
            <div className="ai-practice-view__summary-learning-sections">
              {/* Has aprendido section */}
              {learnedKCs.length > 0 && (
                <div className="ai-practice-view__summary-section">
                  <h3 className="ai-practice-view__summary-section-title">{t('practice_summary_learned')}</h3>
                  <ul className="ai-practice-view__summary-list">
                    {learnedKCs.map((kc, index) => (
                      <li key={index} className="ai-practice-view__summary-list-item">
                        {kc.name}.
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Puntos de mejora section */}
              {improvementKCsWithError.length > 0 && (
                <div className="ai-practice-view__summary-section">
                  <h3 className="ai-practice-view__summary-section-title">{t('practice_summary_improvement')}</h3>
                  <ul className="ai-practice-view__summary-list">
                    {improvementKCsWithError.map((kc, index) => (
                      <li key={index} className="ai-practice-view__summary-list-item">
                        {kc.name}.
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Separator */}
          <div className="ai-practice-view__summary-separator"></div>

          {/* Tus respuestas section */}
          <div className="ai-practice-view__summary-answers-section">
            <h3 className="ai-practice-view__summary-answers-title">{t('practice_summary_your_answers')}</h3>
            <div className="ai-practice-view__summary-responses">
              {activityResults.map((result, index) => (
                <div
                  key={index}
                  className={`ai-practice-view__summary-response-indicator ${
                    result.isCorrect ? 'ai-practice-view__summary-response-indicator--correct' : 'ai-practice-view__summary-response-indicator--incorrect'
                  }`}
                >
                  <span className="ai-practice-view__summary-response-number">{index + 1}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardGeneric>
    </div>
  );
};

ChatbotPracticeSummary.propTypes = {
  userName: PropTypes.string,
  activityResults: PropTypes.arrayOf(
    PropTypes.shape({
      isCorrect: PropTypes.bool,
      response: PropTypes.object,
      activityInstanceId: PropTypes.string,
    })
  ),
  sessionKCs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      score: PropTypes.number.isRequired,
    })
  ),
  lessonTitle: PropTypes.string,
};

export default ChatbotPracticeSummary;
